import { VACANCY_STATUS_MODEL } from '../constants';

export const STATUS_BADGE_SELECT_OPTIONS = [
  { value: VACANCY_STATUS_MODEL.NEW, label: 'Новая' },
  { value: VACANCY_STATUS_MODEL.IN_PROGRESS, label: 'Идёт подбор' },
  {
    value: VACANCY_STATUS_MODEL.SELECTION_SUSPENDED,
    label: 'Подбор приостановлен',
  },
  {
    value: VACANCY_STATUS_MODEL.SELECTION_CANCELLED,
    label: 'Подбор отменен',
  },
  { value: VACANCY_STATUS_MODEL.SELECTION_COMPLETED, label: 'Подбор выполнен' },
  { value: VACANCY_STATUS_MODEL.ARCHIVED, label: 'В архиве' },
];
